import {Offcanvas, Nav, Navbar, Container} from 'react-bootstrap';
import Logo from "./logo.svg";
import {Link} from 'react-router-dom'

function NavBar(){
    return (
<div>
  <Navbar sticky="top" bg="success" variant="dark">
    <Container>
      <Navbar.Brand href="#home">
        <img
          alt=""
          src={Logo}
          width="30"
          height="30"
          className="d-inline-block align-top"
        />{' '}
      Developer's Hub
      </Navbar.Brand>
      <Offcanvas.Body>
        <Nav className="justify-content-end">
          <Nav.Link><Link to="/register" style={{color:"#ffffff"}}>Register</Link>
</Nav.Link>
<Nav.Link><Link to="/login" style={{color:"#ffffff"}}>Login</Link>
</Nav.Link>
          </Nav>
        </Offcanvas.Body>
    </Container>
  </Navbar>
</div>
    )
}

export default NavBar;